import React from "react";
import AdminCategory from "./AdminCategory";

const AdminSubCategory = () => {
  return <AdminCategory defaultTab="subcategories" />;
};

export default AdminSubCategory;